import { render } from "./EmployeeSubordinates.vue?vue&type=template&id=0a8d2b90&scoped=true"
import script from "./EmployeeSubordinates.vue?vue&type=script&lang=js"
export * from "./EmployeeSubordinates.vue?vue&type=script&lang=js"

import "./EmployeeSubordinates.vue?vue&type=style&index=0&id=0a8d2b90&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8d2b90"]])

export default __exports__